import { Box } from '@chakra-ui/react';

import { useAppSystem } from 'Store/app';
import { TextMedium, TextRegular } from 'UiKit/typography';
import { useHostStockPromoState } from 'View/host-stock-promo/state';
import StatusBadge from 'View/host-stock-promo/component/status-badge';
import StoreBadge from 'View/host-stock-promo/component/store-badge';
import formatPromoPeriod from 'View/host-stock-promo/helper/formatPromoPeriod';

import styles from './styles.module.css';

const CardPromo = ({ data }) => {
  const { updateState } = useHostStockPromoState();
  const { onChangeAppSystem } = useAppSystem();

  const storeBadgeData = {
    name: data?.storeName,
    ecommerce: {
      name: data?.ecommerce?.name,
      color: data?.ecommerce?.color,
      logo: data?.ecommerce?.logo,
    },
  };

  return (
    <Box
      className={styles['card-promo-host__container']}
      onClick={() => {
        updateState({ selectedDetailPromo: data });
        onChangeAppSystem({ isHideMobileNavBar: true });
      }}
      data-testid="card-promo"
    >
      <Box className={styles['status__container']}>
        <StatusBadge name={data?.status} />
        <StoreBadge store={storeBadgeData} />
      </Box>
      <Box className={styles['detail__container']}>
        <TextMedium className={styles['name__text']}>{data?.name}</TextMedium>
        <TextRegular className={styles['detail__text']}>
          {data?.promotionProducts?.length} Produk | {formatPromoPeriod(data?.promoPeriod)}
        </TextRegular>
      </Box>
    </Box>
  );
};

export default CardPromo;
